window.addEventListener("load", () => {
    const videoContainers = document.querySelectorAll('[data-video-container]');

    const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
            if (!entry.isIntersecting) return;

            const container = entry.target;
            const video = container.querySelector('video');
            const iframe = container.querySelector('iframe');
            const playButton = container.querySelector('[data-play-video]');

            // Lazy-load poster
            if (video && video.dataset.poster) {
                video.poster = video.dataset.poster;
            }

            // Add click listener once
            if (playButton && !playButton.dataset.listenerAdded) {
                playButton.addEventListener('click', () => {
                    // Play native video
                    if (video) {
                        video.play();
                        playButton.dataset.playing = 'true';

                        if (!video.loop) {
                            video.addEventListener('ended', () => {
                                playButton.dataset.playing = 'false';
                            }, { once: true });
                        }
                    }

                    // Play YouTube or Vimeo iframe
                    if (iframe) {
                        const src = iframe.src;

                        if (src.includes('youtube')) {
                            iframe.contentWindow.postMessage(JSON.stringify({
                                event: "command",
                                func: "playVideo",
                                args: []
                            }), "*");
                        } else if (src.includes('vimeo')) {
                            iframe.contentWindow.postMessage({ method: 'play' }, '*');
                        }

                        playButton.dataset.playing = 'true';
                        // Note: resetting `data-playing` for iframe would require API events
                    }
                });

                playButton.dataset.listenerAdded = 'true'; // ensure listener added only once
            }

            observer.unobserve(container); // stop observing after first intersection
        });
    });

    videoContainers.forEach(container => observer.observe(container));
});
